import { render, staticRenderFns } from "./RodapeListaDePedidos.vue?vue&type=template&id=418f7cb1&scoped=true"
import script from "./RodapeListaDePedidos.vue?vue&type=script&lang=js"
export * from "./RodapeListaDePedidos.vue?vue&type=script&lang=js"
import style0 from "./RodapeListaDePedidos.vue?vue&type=style&index=0&id=418f7cb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418f7cb1",
  null
  
)

export default component.exports